import { useTranslation } from "react-i18next";
var useVehicle = function (setOpenModalEditVehicle) {
    var t = useTranslation().t;
    // Helper functions for status handling
    var getFuelTypeName = function (combustion) {
        switch (combustion) {
            case "GAS": return t("carDetails.fullType.gas");
            case "ELECTRIC": return t("carDetails.fullType.el\u00E9ctrico");
            case "DIESEL": return t("carDetails.fullType.diesel");
            case "GASOLINE": return t("carDetails.fullType.gasolina");
            default: return "";
        }
    };
    // Helper function to prepare car details
    var getCarDetails = function (responseData, price) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var car = {
            id: 1,
            brand: (_b = (_a = responseData === null || responseData === void 0 ? void 0 : responseData.contentMap) === null || _a === void 0 ? void 0 : _a.brand) === null || _b === void 0 ? void 0 : _b.name,
            model: (_d = (_c = responseData === null || responseData === void 0 ? void 0 : responseData.contentMap) === null || _c === void 0 ? void 0 : _c.model) === null || _d === void 0 ? void 0 : _d.name,
            fueltype: (_e = responseData === null || responseData === void 0 ? void 0 : responseData.contentMap) === null || _e === void 0 ? void 0 : _e.combustion,
            color: (_g = (_f = responseData === null || responseData === void 0 ? void 0 : responseData.contentMap) === null || _f === void 0 ? void 0 : _f.colors) === null || _g === void 0 ? void 0 : _g.name,
            price: "RD$ ".concat(price),
            cylinders: (_h = responseData === null || responseData === void 0 ? void 0 : responseData.contentMap) === null || _h === void 0 ? void 0 : _h.cylinders,
            plate: (_j = responseData === null || responseData === void 0 ? void 0 : responseData.contentMap) === null || _j === void 0 ? void 0 : _j.plate,
        };
        return car;
    };
    var updateVehicle = function (e) {
        switch (e.id) {
            case "1":
                setOpenModalEditVehicle(true);
        }
    };
    return {
        updateVehicle: updateVehicle,
        getFuelTypeName: getFuelTypeName,
        getCarDetails: getCarDetails,
    };
};
export default useVehicle;
